import { useEffect, useState } from "react";
import { Database, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const CatalogResults = ({ query, onAdd }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const q = query.trim();
    if (q.length < 3) {
      setItems([]);
      return undefined;
    }
    let alive = true;
    const t = setTimeout(() => {
      api.get("/catalog/search", { params: { q } }).then((r) => alive && setItems(r.data)).catch(() => alive && setItems([]));
    }, 250);
    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [query]);

  if (!items.length) return null;
  return (
    <div className="rounded-xl border border-[#2E252A] bg-[#161214] mb-6 rise" data-testid="catalog-results">
      <p className="flex items-center gap-2 px-4 pt-4 pb-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#6E665D]">
        <Database className="w-3.5 h-3.5" /> Wine database · {items.length}{items.length >= 20 ? "+" : ""} match{items.length === 1 ? "" : "es"} — keep typing to narrow
      </p>
      <div className="max-h-80 overflow-y-auto px-2 pb-2">
        {items.map((c) => (
          <div key={c.id} className="flex items-center gap-3 rounded-md px-2 py-2.5 hover:bg-[#1E181B] transition-colors" data-testid={`catalog-result-${c.id}`}>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-[#F5F0EB] truncate">{c.display_name}</p>
              <p className="text-xs text-[#6E665D] truncate">{[c.producer, c.color, c.country, c.region, c.sub_region].filter(Boolean).join(" · ")}</p>
            </div>
            <Button size="sm" onClick={() => onAdd(c)} className="h-8 shrink-0 bg-[#5C1D24] hover:bg-[#8C2B36] text-[#F5F0EB]" data-testid={`catalog-add-${c.id}`}>
              <Plus className="w-3.5 h-3.5 mr-1" />Add to My Cellar
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
